import React from "react";

const ObjectDetailsAerialInfo = ({ pointDetailOffcanvas }) => {
  const lampTypes = {
    SOD: "Vapor de Sódio",
    MET: "Vapor Metálico",
    MER: "Vapor de Mercúrio",
    FLU: "Fluorescente",
    LED: "LED",
    null: "Não definido",
  };

  return (
    <tbody>
      <tr>
        <th>Latitude:</th>
        <td>
          {pointDetailOffcanvas && pointDetailOffcanvas.point.latitude
            ? Math.floor(pointDetailOffcanvas.point.latitude * 1000000) /
              1000000
            : "-"}
        </td>
      </tr>
      <tr>
        <th>Longitude:</th>
        <td>
          {pointDetailOffcanvas && pointDetailOffcanvas.point.longitude
            ? Math.floor(pointDetailOffcanvas.point.longitude * 1000000) /
              1000000
            : "-"}
        </td>
      </tr>
      <tr>
        <th>Tipo de lâmpada:</th>
        <td>
          {pointDetailOffcanvas &&
          pointDetailOffcanvas.point.lamp_type &&
          pointDetailOffcanvas.point.lamp_type !== ""
            ? lampTypes
              ? lampTypes[pointDetailOffcanvas.point.lamp_type]
              : pointDetailOffcanvas.point.lamp_type
            : "Não definido"}
        </td>
      </tr>
      <tr>
        <th>Potência estimada:</th>
        <td>
          {pointDetailOffcanvas &&
          pointDetailOffcanvas.point.lamp_power &&
          pointDetailOffcanvas.point.lamp_power !== ""
            ? pointDetailOffcanvas.point.lamp_power + "w"
            : "Não definido"}
        </td>
      </tr>
    </tbody>
  );
};

export default ObjectDetailsAerialInfo;
